var React = require('react/addons');
var cx = require('classnames');
var $ = require('jquery');
var _ = require('underscore');

var GalleryItem = React.createClass({

  propTypes: {
    url: React.PropTypes.string.isRequired,
    width: React.PropTypes.number.isRequired,
    height: React.PropTypes.number.isRequired,
    active: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {};
  },

  getInitialState: function() {
    return {
      style: {}
    };
  },

  componentWillReceiveProps: function() {
    this.setState({style: {}});
  },

  scaleImage: function() {
    var $el = $(this.getDOMNode());
    var elWidth = $el.width();
    var elHeight = $el.height();

    var ratio = this.props.width / this.props.height;
    var elRatio = elWidth / elHeight;

    var height;
    var width;
    var top = 0;
    var left = 0;

    if (elRatio >= ratio) {
      // Image should be full height and centred horizontally
        height = elHeight;
        width = elHeight * ratio;
        left = (elWidth - width) / 2;
    } else {
      // Image should be full width and centred vertically
        width = elWidth;
        height = elWidth / ratio;
        top = (elHeight - height) / 2;
    }

    this.setState({
      style: {
        width: width,
        height: height,
        top: top,
        left: left
      }
    });
  },

  componentDidMount: function() {
    this.setState({style: {}});
    this.scaleImage();
    $(window).on('resize.gallery', this.scaleImage);
  },

  shouldComponentUpdate: function(nextProps, nextState) {
    return !_.isEqual(nextProps, this.props) || !_.isEqual(nextState, this.state);
  },

  componentDidUpdate: function() {
    this.scaleImage();
  },

  componentWillUnmount: function() {
    $(window).off('resize.gallery');
  },

  render: function() {
    var style = this.state.style;

    var classes = cx({
      'react-gallery-item': true,
      'active': this.props.active
    });

    return (
      <div className={classes}>
        <div className="wrapper" style={style}>
          <img src={this.props.url} />
        </div>
      </div>
    );
  }

});

module.exports = GalleryItem;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/components/gallery/gallery-item.jsx
 **/